import { enumAttribute, stringAttribute } from "../controller/attribute"

export const WORMHOLE_DOMAINS = ["employee", "customer"] as const

export type WormholeDomain = (typeof WORMHOLE_DOMAINS)[number]

export const wormholeContract = {
  clientDomain: enumAttribute("domain", WORMHOLE_DOMAINS),
  activeAccountNumber: stringAttribute("tastyworks-account"),
} as const
